import {ReactNode} from "react";

/** Coupon (promo code) apply flow status */
export const CouponStatus = {
    Idle: "idle",
    Applying: "applying",
    Applied: "applied",
    Error: "error",
} as const;

export type CouponStatus = (typeof CouponStatus)[keyof typeof CouponStatus];

export interface BookingDetails {
    label: string;
    value: string | ReactNode;
}

export interface BookingSummaryRow {
    label: string;
    amount?: string;
    bold?: boolean;
    highlighted?: boolean;
    highlightedPlain?: boolean;
    discount?: boolean;
}

export interface CollapsibleRow {
    label: string;
    amount: string;
}

/** Rent summary with translation key and formatted amount */
export interface RentSummary {
    labelKey: string;
    labelParams: {price: string; nights: number};
    amount: string;
}

/** Expected charge row with translation key and optional date for interpolation */
export interface ExpectedChargeRow {
    labelKey: "dueToday" | "dueOn";
    date?: string; // formatted date string, e.g. "Aug 14"
    amount: string;
}
